import { useEffect, useRef } from "react";
import { mountLogo, type MountLogoOptions } from "../lib/logo";
import styles from "./Logo.module.css";

type LogoProps = MountLogoOptions;

/**
 * Animated WebGL logo. Mounts via useEffect with cleanup so React strict-mode
 * double-mount in dev doesn't leak canvases or animation frames.
 */
export function Logo({ ...opts }: LogoProps) {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    let stop: (() => void) | null = null;
    let cancelled = false;

    mountLogo(el, opts).then((s) => {
      if (cancelled) {
        s();
      } else {
        stop = s;
      }
    });

    return () => {
      cancelled = true;
      if (stop) stop();
    };
    // We intentionally serialise opts shallowly — the parent passes a stable
    // option set, and re-running the effect on every render would re-mount
    // the canvas every animation frame.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div ref={ref} className={styles.logoWrap} />;
}
